import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	getCommCodes: codeType => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getRepayMst: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		let startDcsnDdBe = moment(searchParams.startDcsnDd).subtract('1', 'M').format('YYYYMM');
		let endDcsnDdBe = moment(searchParams.endDcsnDd).subtract('1', 'M').format('YYYYMM');
		let startDcsnDd = moment(searchParams.startDcsnDd).format('YYYYMM');
		let endDcsnDd = moment(searchParams.endDcsnDd).format('YYYYMM');
		if (
			searchParams.dlrCpnyNm !== undefined ||
			searchParams.slipScn !== undefined ||
			searchParams.startDcsnDd !== undefined ||
			searchParams.causPartNo !== undefined ||
			searchParams.endDcsnDd !== undefined ||
			searchParams.clmDd02 !== undefined ||
			searchParams.ctype !== undefined
		) {
			queryStr = objectToQuerystring({
				dlrCpnyNm: searchParams.dlrCpnyNm, //실납품사
				slipScn: searchParams.slipScn, //전표구분
				ctype: searchParams.ctype, //ctype
				clmDd02: searchParams.clmDd02, //날짜구분값(10.변제확정일 20. R/O확정일)
				causPartNo: searchParams.causPartNo, //품번
				startDcsnDd: startDcsnDd, //확정일자from
				endDcsnDd: endDcsnDd, //확정일자to
				startDcsnDdBe: startDcsnDdBe, //확정일자 전달from
				endDcsnDdBe: endDcsnDdBe, //확정일자 전달to
				currentPage,
				pageUnit
			});
		}
		//console.log('queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/qlty/repayMst/v1/repayMsts` + queryStr)
			.then(response => {
				return response.data;
			})
			.catch(error => {
				throw error.response.data;
			});
	}
};
